import React from 'react';

const MessageCitations = ({ citations }) => {
  if (!citations || citations.length === 0) return null;

  const getCitationUrl = (citation) => (
    typeof citation === 'string' ? citation : citation?.url || ''
  );

  const getCitationTitle = (citation) => (
    typeof citation === 'string' ? '' : citation?.title || ''
  );

  const getDomainName = (citation) => {
    const url = getCitationUrl(citation);
    try {
      const hostname = new URL(url).hostname;
      const cleanHostname = hostname.replace(/^www\./, '');
      const parts = cleanHostname.split('.');
      return parts.length > 1 ? parts[parts.length - 2] : cleanHostname;
    } catch (error) {
      return url;
    }
  };

  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {citations.map((citation, index) => {
        const domain = getDomainName(citation);
        const url = getCitationUrl(citation);
        const title = getCitationTitle(citation);
        if (!url) return null;
        return (
          <a
            key={`${url}-${index}`}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title={title || url}
            className="inline-flex items-center px-3 py-1 rounded-full bg-[rgb(219,219,215)] dark:bg-[rgb(35,35,35)] text-black dark:text-white text-sm hover:bg-[rgb(200,200,196)] dark:hover:bg-[rgb(50,50,50)] transition-colors"
          >
            {index + 1}. {domain}
          </a>
        );
      })}
    </div>
  );
};

export default MessageCitations;
